import { Component, Renderer2 } from '@angular/core';
import { ListGroupsBaseComponent } from '../list-groups-base.component';

@Component({
  selector: 'app-list-groups-desktop-tablet',
  templateUrl: './list-groups-desktop-tablet.component.html',
  styleUrls: ['./list-groups-desktop-tablet.component.scss'],
})
export class ListGroupsDesktopTabletComponent extends ListGroupsBaseComponent {
  addGroupButtonElement: Element;
  newGroupCard: {
    groupName: string;
    groupNameExists: boolean;
    enableCreateGroupButton: boolean;
  };
  trimmedGroupName: string;

  constructor(private renderer: Renderer2) {
    super();
  }

  insertNewGroupCard() {
    if (!this.newGroupCard) {
      this.addGroupButtonElement = document.querySelector('#add-group-button');
      if (this.addGroupButtonElement) {
        this.removeClass(
          this.addGroupButtonElement,
          'usf-outline-green-button',
        );
        this.addClass(this.addGroupButtonElement, 'usf-fill-disabled-button');
      }
      this.newGroupCard = {
        groupName: null,
        groupNameExists: false,
        enableCreateGroupButton: false,
      };
    }
  }

  removeNewGroupCard() {
    this.newGroupCard = undefined;
    if (this.addGroupButtonElement) {
      this.removeClass(this.addGroupButtonElement, 'usf-fill-disabled-button');
      this.addClass(this.addGroupButtonElement, 'usf-outline-green-button');
    }
  }

  removeClass(element: Element, className: string) {
    this.renderer.removeClass(element, className);
  }

  addClass(element: Element, className: string) {
    this.renderer.addClass(element, className);
  }

  getGroupNameExists() {
    this.trimmedGroupName = this.newGroupCard.groupName.trim();

    this.newGroupCard.groupNameExists = this.groupNameExists();

    this.newGroupCard.enableCreateGroupButton = this.newGroupCard
      .groupNameExists
      ? false
      : true;
  }

  onCreateGroup() {
    this.newGroupCard.groupName = this.trimmedGroupName;
    this.createGroupEmitter.emit(this.newGroupCard.groupName);
    this.removeNewGroupCard();
    this.trimmedGroupName = '';
  }

  groupNameExists() {
    for (const group of this.groups) {
      if (
        this.trimmedGroupName?.toLowerCase() ===
        group?.groupName?.toLowerCase().trim()
      ) {
        return true;
      }
    }
    return false;
  }
}
